module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAATCAYAAACdkl3yAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADOSURBVHgB7ZTLDYJAEIb/IXjHDihBK5ASLMEONFHUq2cO0oGxBDrQCqQDtQK5Gxx/TDA85GHCkS9Z2NndfJnd7KygyEItfi00E8GXKA3M3NRGD3hhhnYkkmFZtNQpFA6enBzgAU+kUrFVGzGu2SHj2xOMKDpl0/0HAx3Ri3pRF5iF2MZa97zhgMu6qyIuF3VR5FByY9uhnjvbuU4UsOYC/udoh18WCTMBJjy1kKkfGxWCKB9mcfXCbdmUNb8AyjWejH+LElbqoA3yEYVp+AYeWzJ9ZljrqAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/afl/con/book.png
// module id = 458
// module chunks = 438